<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true"  size="mini">
                <el-form-item>
					<el-input placeholder="内容" v-model="facname" ></el-input>
				</el-form-item>
				<el-form-item>
					<form-query-button  @select-type="getData" >  </form-query-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="factors" highlight-current-row v-loading="listLoading" style="width: 100%;" border :height="formHeight" size="mini">
			<!-- <el-table-column type="selection" width="55">
			</el-table-column> -->
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
			<el-table-column prop="type" label="适用数据类型">
				<template slot-scope="scope">
					<span v-if="scope.row.type=='minute'">分钟 </span>
					<span v-else-if="scope.row.type=='hour'">小时 </span>
					<span v-else>天 </span>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="内容">
			</el-table-column>
			<el-table-column prop="useFlag" label="是否开启">
				<template slot-scope="scope">
					<span v-if="scope.row.useFlag==1">是 </span>
					<span v-else>否 </span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<span v-if="scope.row.useFlag==1">
						<el-button type="text" plain  icon="el-icon-turn-off" v-on:click="changeStatus(0, scope.row)" >关闭</el-button>
					</span>
					<span v-else>
						<el-button type="text" plain  icon="el-icon-open" v-on:click="changeStatus(1, scope.row)" >开启</el-button>
					</span>
				</template>
			</el-table-column>
		</el-table>

	</section>
</template>

<script>
	import {getFactors, getExceptionList ,changeExceptionStatus} from '../../api/api';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

export default {
	components: { FormQueryButton },
		data() {
			return {
				factors: [ ],
                form:{
                    factorid:'',
                    min:'',
                    max:'',
                    sequence:''
                },
				total: 0,
                page:1,
				pageSize:10,
				listLoading: false,

				formVisible: false,//修改界面是否显示
                loading: false,
				formHeight:0,
				facname:"",
				FactorList:[],
				type:""
			}
		},
		methods: {
            cancleSubmit(){
                this.formVisible=false;
            },
			getData(){
				let para = {
					facname: this.facname
				};
				this.listLoading = true;
				getExceptionList(para).then((res) => {
					this.listLoading = false;
					this.factors = res.data.ReviewConditions;
				});
			},
			changeStatus(type,row){

				let param = new URLSearchParams();
				param.append('useflag', type);
				param.append('id', row.id);

				this.listLoading = true;
				changeExceptionStatus(param).then((res) => {
					this.listLoading = false;
					if (res.data.Result != true) {
							this.$message({
							message: "操作失败",
							type: 'error'
						})}else{
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}
						this.getData();
				});
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-100;
			},
			//查询因子信息
			getFactors() {
				if(this.FactorList.length>0){
					return;
				}
				this.listLoading = true;
				getFactors().then((res) => {
					this.FactorList = res.data;
					this.listLoading = false;
				});
			},
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.getData();
		}
	}

</script>
<style>
	#colorUL {
		height: 250px;
	}
	#colorUL li{
		float: left;
		list-style: none;
		width: 20%;
		margin: 5px 0;
	}
	.color{
		float: left;
		width: 60px;
		height: 30px;
		margin-right: 5px;
	}
	#colorUL .colorNum{
		float: left;
		width: 70px;
	}
</style>



// WEBPACK FOOTER //
// ReviewCondition.vue?67fade4b